import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {clsx} from "@/utils/clsx";
import styles from "./index.module.scss";
import {useTranslation} from "react-i18next";
import {Title} from "@/components/ui/Title/Title";
import {Button} from "@/components/ui/Button/Button";
import {formatRemaining} from "@/utils/formatRemaining";
import {
  useClaimCheckMutation,
  useClaimGetQuery,
  useClaimPostMutation,
} from "@/api/endpoints/claim";
import {useEffect, useState} from "react";
import {useAuthMutation, useAuthQuery} from "@/hooks/useAuthApi.ts";

export const Route = createFileRoute("/_mainLayout/claim/")({
  component: RouteComponent,
});

function RouteComponent() {

  return <></>

  // const {t} = useTranslation("claim");
  //
  // const errKeyMap: Record<string, "errors.invalidCode" | "errors.codeExpired" | "errors.codeRequired"> = {
  //   "Invalid code": "errors.invalidCode",
  //   "The code is expired.": "errors.codeExpired",
  //   "The code is required.": "errors.codeRequired",
  // };
  //
  // const jwt = localStorage.getItem("joinToken");
  // const {data: claim} = useAuthQuery(useClaimGetQuery,jwt ? {join: jwt} : undefined);
  // const [check] = useAuthMutation(useClaimCheckMutation);
  // const [post] = useAuthMutation(useClaimPostMutation);
  //
  // const [code, setCode] = useState("");
  // const [checked, setChecked] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [checking, setChecking] = useState(false);
  // const [claiming, setClaiming] = useState(false);
  // const navigate = useNavigate();
  //
  // // Сбрасываем результаты предыдущей проверки, если код меняют
  // useEffect(() => {
  //   if (checked || error) {
  //     setChecked(false);
  //     setError(null);
  //   }
  // }, [code]);
  //
  // // Нажали «Check»
  // async function onCheck() {
  //   setChecking(true);
  //   setError(null);
  //   try {
  //     const res = await check({code});
  //     if (res?.data?.status !== "ok") {
  //       const err = res.error as {
  //         data?: { error?: string };
  //       };
  //       const key = err?.data?.error ? errKeyMap[err.data.error] : undefined;
  //       throw new Error(t(key ?? "errors.invalidCode"));
  //     }
  //     // если ответ OK
  //     setChecked(true);
  //   } catch (error) {
  //     setError(error instanceof Error ? error.message : String(error));
  //   } finally {
  //     setChecking(false);
  //   }
  // }
  //
  // // Нажали «Claim»
  // async function onClaim() {
  //   setClaiming(true);
  //   try {
  //     await post({code: checked ? code : ""});
  //     localStorage.removeItem("joinToken");
  //     await navigate({to: "/"});
  //   } catch (e) {
  //     console.warn(e);
  //   }
  // }
  //
  // return (
  //   <div className={clsx(styles.claim)}>
  //     <div className={clsx(styles.inner)}>
  //       <div className={clsx(styles.text)}>{t("total")}</div>
  //       <Title variant="green" className={clsx(styles.title)}>
  //         {checked && claim?.znx_amount
  //           ? claim.znx_amount * 2
  //           : claim?.znx_amount}{" "}
  //         {t("ZNX")}
  //       </Title>
  //       <div className={clsx(styles.expired)}>
  //         {formatRemaining(claim?.expire_at || new Date().toLocaleDateString())}
  //       </div>
  //       <div className={clsx(styles.notice)}>
  //         <span>{t("notice.white")}</span>{" "}
  //         <span className={clsx(styles.green)}>{t("notice.green")}</span>
  //       </div>
  //       {/*<div className={styles.row}>*/}
  //       {/*  <input*/}
  //       {/*    type="text"*/}
  //       {/*    className={`*/}
  //       {/*    ${styles.input}*/}
  //       {/*    ${checked ? styles.inputSuccess : ""}*/}
  //       {/*    ${error ? styles.inputError : ""}*/}
  //       {/*  `}*/}
  //       {/*    placeholder="0000 0000 0000 0000"*/}
  //       {/*    value={code}*/}
  //       {/*    onChange={(e) => setCode(e.target.value)}*/}
  //       {/*  />*/}
  //       {/*  <Button*/}
  //       {/*    variant="primary"*/}
  //       {/*    className={styles.checkButton}*/}
  //       {/*    onClick={onCheck}*/}
  //       {/*    disabled={checking || code.trim() === ""}*/}
  //       {/*  >*/}
  //       {/*    {checking ? "…" : t("check")}*/}
  //       {/*  </Button>*/}
  //       {/*  <div className={styles.message}>*/}
  //       {/*    {error && <div className={styles.error}>{error}</div>}*/}
  //       {/*    {!error && <div className={styles.tooltip}>{t("tooltip")}</div>}*/}
  //       {/*  </div>*/}
  //       {/*</div>*/}
  //
  //       <Button
  //         variant="primary"
  //         className={styles.claimButton}
  //         onClick={onClaim}
  //         disabled={claiming}
  //       >
  //         {claiming ? "…" : t("button")}
  //       </Button>
  //     </div>
  //   </div>
  // );
}
